import { Row } from "@/components/Row";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

// A labeled on/off switch row for filter and options dropdown menus.
export const FilterSubMenuSwitch = ({
  label,
  checked,
  onCheckedChange,
}: {
  label: string;
  checked: boolean;
  onCheckedChange: (next: boolean) => void;
}) => {
  const id = `filter-switch-${label.replace(/\s+/g, "-").toLowerCase()}`;
  const render = () => (
    <DropdownMenuItem
      className="cursor-pointer focus:bg-slate-50"
      onSelect={(e) => {
        e.preventDefault();
        onCheckedChange(!checked);
      }}
    >
      <Row className="w-full items-center justify-between gap-2">
        <Label className="cursor-pointer font-normal" htmlFor={id}>
          {label}
        </Label>
        <Switch
          checked={checked}
          id={id}
          onCheckedChange={onCheckedChange}
          onClick={(e) => {
            e.stopPropagation();
          }}
        />
      </Row>
    </DropdownMenuItem>
  );

  return render();
};
